import { Injectable, signal } from '@angular/core';

/**
 * Estado global del panel lateral derecho de la Guía de usuario.
 * El botón de ayuda del header lo abre; el drawer vive en el layout full
 * (mismo patrón que el drawer de chat de Chatwoot).
 */
@Injectable({ providedIn: 'root' })
export class GuiaPanelStateService {
    /** true → el drawer de la guía está visible. */
    readonly visible = signal(false);

    /** Texto del buscador de la guía. Se conserva entre aperturas del panel. */
    readonly busqueda = signal('');

    abrir(): void {
        this.visible.set(true);
    }

    cerrar(): void {
        this.visible.set(false);
    }

    alternar(): void {
        this.visible.update((v) => !v);
    }
}
